import { __awaiter } from '../../_virtual/_tslib.js';
import classNames from 'classnames';
import React__default, { useRef, useState, useEffect } from 'react';
import ValidationError from '../validation-error/ValidationError.js';
import { timer } from '../../methods/timer.js';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import '../../constants/serviceTypeId.js';
import '../../constants/StateList.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';
import 'bowser';
import { sleep } from '../../methods/sleep.js';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import Styles from './OtpInput.module.scss.js';

const OtpInput = ({ onChange, error, onClickResendOtp, wraperClass, resendbtnClass, errorStyle, otpFieldClass, placeholder, maxLength, fieldType = "Default", resendOtpDuration = 30 }) => {
    // const [otpAttempts, setOtpAttempts] = useState(1);
    // const [, setElem] = useState<HTMLInputElement>();
    // const [activeInput, setActiveInput] = useState(0);
    // const [otpValues, setOTPValues] = useState(Array<string>(4).fill(""));
    const inputRef = useRef(null);
    const submitRef = useRef(null);
    const [isDirty, setIsDirty] = useState(false);
    const [timeRemaining, setTimeRemaining] = useState(resendOtpDuration);
    const [isResendingOtp, setIsResendingOtp] = useState(false);
    // const _onBlur = (e: FocusEvent<HTMLInputElement>) => {
    //     setIsDirty(!!e.target.value);
    // };
    // const refFunc = (elem: HTMLInputElement) => {
    //     setTimeout(() => {
    //         setElem(elem);
    //         elem?.focus();
    //     }, 100);
    // };
    const _onClickResendOtp = () => __awaiter(void 0, void 0, void 0, function* () {
        // if (otpAttempts < MAX_OTP_SENT) {
        setIsResendingOtp(true);
        setTimeRemaining(resendOtpDuration);
        yield (onClickResendOtp === null || onClickResendOtp === void 0 ? void 0 : onClickResendOtp({
            onSuccessCallback: () => {
                timer(resendOtpDuration, (t) => {
                    setIsResendingOtp(false);
                    setTimeRemaining(t);
                });
            }
        }));
        // setOtpAttempts((state) => state + 1);
        // }
    });
    useEffect(() => {
        const timerId = timer(resendOtpDuration, (t) => {
            setTimeRemaining(t);
        });
        return () => clearInterval(timerId);
    }, []);
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);
    const [otpArr, setOtpArr] = useState(new Array(maxLength ? maxLength : 4).fill(""));
    const handleChange = (e, index) => __awaiter(void 0, void 0, void 0, function* () {
        if (isNaN(e.target.value))
            return false;
        if (e.nativeEvent.inputType === "insertFromPaste") {
            const newArr = e.target.value.split("");
            setOtpArr(newArr);
        }
        else {
            const newArr = [...otpArr.map((d, idx) => (idx === index ? e.target.value : d))];
            setOtpArr(newArr);
            //Focus next input
            if (e.target.nextSibling && e.target.value !== "") {
                e.target.nextSibling.focus();
            }
            e.target.value = newArr.join("");
        }
        const _val = e.target.value;
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
        if (_val.length === (maxLength || 4)) {
            setIsDirty(!!_val);
        }
        else {
            setIsDirty(false);
        }
        // alert(e.nativeEvent.inputType);
        if (e.nativeEvent.inputType === "deleteContentBackward") {
            yield sleep(100);
            if (e.target.value === "") {
                if (e.target.previousSibling) {
                    e.target.previousSibling.focus();
                }
            }
        }
    });
    const handleKeyPress = (event, element) => __awaiter(void 0, void 0, void 0, function* () {
        // alert(event.keyCode);
        if (event.key === "Backspace" || event.key === "Delete") {
            yield sleep(100);
            if (element.value === "") {
                if (element.previousSibling) {
                    element.previousSibling.focus();
                }
            }
        }
    });
    // const focus = () => {
    //     setTimeout(() => {
    //         // elem?.focus();
    //         inputRef.current?.focus();
    //     }, 1);
    // };
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputRef]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: Styles.otpInputsWrap }, otpArr.map((data, index) => (React__default.createElement("input", { ref: index === 0 ? inputRef : null, autoFocus: index === 0, key: index, name: "otp", 
            // maxLength={index !== 3 ? 4 : 1}
            maxLength: maxLength ? (index !== maxLength - 1 ? maxLength : 1) : index !== 3 ? 4 : 1, className: classNames(Styles.otp_field, otpFieldClass, Styles[fieldType]), value: data, placeholder: placeholder, onChange: () => { }, onInput: (e) => handleChange(e, index), onFocus: (e) => e.target.select(), onKeyDown: (e) => handleKeyPress(e, e.target), autoComplete: "new-password", inputMode: "numeric" })))),
        React__default.createElement("button", { ref: submitRef, type: "submit", style: { display: "none" } }),
        React__default.createElement(ValidationError, { error: isDirty ? error : "", style: Object.assign({ marginTop: 18, position: "relative", top: "-35px", left: "3px" }, errorStyle) }),
        React__default.createElement("button", { disabled: timeRemaining > 0 || isResendingOtp, className: classNames(Styles.otpResend, timeRemaining === 0 && Styles.active, resendbtnClass, Styles[fieldType]), onClick: _onClickResendOtp, style: { marginBottom: "12px" } }, isResendingOtp
            ? "Resending OTP..."
            : `Didn’t receive OTP? Resend ${timeRemaining > 0 ? `in ${timeRemaining} seconds` : ""}`)));
};

export { OtpInput as default };
//# sourceMappingURL=OtpInput.js.map
